module.exports = __webpack_public_path__ + "static/media/280819.5658eb88.png";